module.exports = __webpack_public_path__ + "img/bell.a8b2e1e6.svg";